export default __webpack_public_path__ + "assets/monaco-flag.png";